module.exports = __webpack_public_path__ + "static/media/maher.7a5c7393.jpeg";